import { http } from './http';
import { baseURL, wpCommentsEndpoint } from './wpConfig';
import { RESTComment, CommentsResponse } from './types';
import { UserCredentials } from './wpAuth';

const parsePaginationHeaders = (headers: Headers) => ({
    totalPages: parseInt(headers.get("x-wp-totalpages") ?? "1", 10),
    totalComments: parseInt(headers.get("x-wp-total") ?? "0", 10),
});

export const getComments = async (page: number): Promise<CommentsResponse> => {
    const endPoint: string = `${baseURL}${wpCommentsEndpoint}?page=${page}&per_page=10&orderby=date&order=desc`;
    const { data, headers } = await http.getWithHeaders<RESTComment[]>(endPoint);
    return { comments: data, ...parsePaginationHeaders(headers) };
};

export const getPostAllComments = (postId: number): Promise<RESTComment[]> => {
    const endPoint: string = baseURL + wpCommentsEndpoint + "?post=" + postId + "&orderby=date&order=asc&per_page=100";
    return http.get<RESTComment[]>(endPoint);
};

export const createComment = (userCredentials: UserCredentials, comment: RESTComment): Promise<RESTComment> => {
    const endPoint: string = baseURL + wpCommentsEndpoint;
    return http.post<RESTComment>(endPoint, comment, { auth: userCredentials });
};

export const deleteComment = (userCredentials: UserCredentials, commentId: number): Promise<RESTComment> => {
    const endPoint: string = `${baseURL}${wpCommentsEndpoint}/${commentId}`;
    return http.del<RESTComment>(endPoint, { auth: userCredentials });
};
